// extracted by mini-css-extract-plugin
export default {"container":"LocationsHours_container__i2xlf","row":"LocationsHours_row__lrZxt","today":"LocationsHours_today__XpzOx"};